import { toast } from "sonner";

const csvEscape = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

// rows: array of arrays (first row = header). excel=true writes an HTML table Excel opens natively.
export function downloadTable(rows, filename, excel = false) {
  const body = excel
    ? `<table>${rows.map((r) => `<tr>${r.map((c) => `<td>${String(c ?? "").replace(/</g, "&lt;")}</td>`).join("")}</tr>`).join("")}</table>`
    : rows.map((r) => r.map(csvEscape).join(",")).join("\n");
  const blob = new Blob([excel ? body : `\ufeff${body}`], { type: excel ? "application/vnd.ms-excel" : "text/csv;charset=utf-8" });
  const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(blob), download: `${filename}.${excel ? "xls" : "csv"}` });
  a.click();
  URL.revokeObjectURL(a.href);
  toast.success(excel ? "Excel file downloaded" : "CSV downloaded");
}
